type TFrameCommonProps = {
	text: string
	fontSize: number
}

type TFramePreviewModeProps = TFrameCommonProps & {
	previewMode: true
	previewText?: string
	textLength?: number
}

type TFrameNormalModeProps = TFrameCommonProps & {
	previewMode: false
	patternMarkup: string
	frameColor: string
	textColor: string
	frameBackgroundColor: string
	patternBackgroundColor: string
}

export type TQrFrameProps = TFramePreviewModeProps | TFrameNormalModeProps

export function isNormalFrameMode(
	props: TQrFrameProps,
): props is TFrameNormalModeProps {
	return !props.previewMode
}
